import React, { Component } from 'react';
import { AlertCircle } from 'lucide-react';
interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}
interface State {
  hasError: boolean;
  error: Error | null;
}
export default class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null
  };
  public static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error
    };
  }
  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }
  public render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }
      return <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4" data-id="element-320" data-mp="rv102rnivvj4">
          <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center" data-id="element-321" data-mp="1y9a4pypzh258">
            <div className="flex justify-center mb-4" data-id="element-322" data-mp="238lmnb236doe">
              <AlertCircle className="h-16 w-16 text-red-500" data-id="element-323" data-mp="23b7tt9l2er63" />
            </div>
            <h1 className="text-2xl font-serif font-bold text-primary mb-4" data-id="element-324" data-mp="155p92icgs91d">
              Something went wrong
            </h1>
            <p className="text-slate-dark mb-6" data-id="element-325" data-mp="v8arugipvg80">
              We apologize for the inconvenience. Please try refreshing the page
              or contact us if the problem persists.
            </p>
            <button onClick={() => window.location.reload()} className="bg-primary text-white px-6 py-3 rounded-md hover:bg-primary-light transition-colors" data-id="element-326" data-mp="m7mg5sgsprya">
              Refresh Page
            </button>
          </div>
        </div>;
    }
    return this.props.children;
  }
}